let activeLiElement = null;

function handleImageHover(event) {
  activeLiElement = event.target.parentElement.querySelector('.variant-image.active');

  const liElement = event.target;
  updateCardWithVariant(liElement);
}

function handleImageClick(event) {
  const liElement = event.target;
  updateCardWithVariant(liElement, true);
  activeLiElement = liElement;
}

function handleImageMouseOut(event) {
  updateCardWithVariant(activeLiElement);
}

function updateCardWithVariant(liElement, isClick = false) {
  if (!liElement) return;

  const cardInner = liElement.closest('.card');

  setActivePrice(cardInner, liElement);
  updateCardMedia(liElement, cardInner, isClick);

  isClick && setActiveClass(liElement, cardInner);
}

function setActiveClass(liElement, cardInner) {
  const siblings = cardInner.querySelectorAll('.variant-image');
  for (let sibling of siblings) {
    if (sibling !== liElement) {
      sibling.classList.remove('active');
    }
  }
  liElement.classList.add('active');
}

function setActivePrice(cardInner, liElement) {
  const cardPriceActiveContainer = cardInner.querySelector('[data-card-price-active]');
  const variantPrice = liElement.querySelector('[data-variant-price]');
  if (!variantPrice) return;
  cardPriceActiveContainer.innerHTML = variantPrice.innerHTML;
}

function getImageAttributes(img) {
  return img
    ? {
        dataSrc: img.getAttribute('data-src'),
        dataHoverSrc: img.getAttribute('data-hover-src'),
        dataUrl: img.getAttribute('data-url'),
        dataBadge: img.getAttribute('data-badge'),
        dataSecondaryBadges: img.getAttribute('data-secondary-badges').split(',').filter(Boolean),
      }
    : {};
}

function updateCardMedia(liElement, cardInner, isClick) {
  const liImg = liElement.querySelector('img');
  const { dataSrc, dataUrl, dataBadge, dataHoverSrc, dataSecondaryBadges } = getImageAttributes(liImg);
  const anchors = cardInner.querySelectorAll('a');
  const featuredMedia = cardInner.querySelector('img[data-card-featured-image]');
  const hoverMedia = cardInner.querySelector('img[data-card-hover-image]');
  const badgePrimary = cardInner.querySelector('.badge-wrapper.badge-wrapper--primary');
  const badgeSecondary = cardInner.querySelector('.badge-wrapper.badge-wrapper--secondary');
  featuredMedia.src = dataSrc;

  if (dataHoverSrc && isClick) {
    hoverMedia.src = dataHoverSrc;
    preloadImage(dataHoverSrc);
  }

  cardInner.classList.toggle('card--hover-image', !!dataHoverSrc);

  anchors.forEach((anchor) => {
    anchor.href = dataUrl;
  });
  if (badgePrimary) {
    badgePrimary.innerHTML = '';
    if (dataBadge) badgePrimary.innerHTML = `<span class="badge badge--primary">${dataBadge}</span>`;
  }

  if (badgeSecondary) {
    badgeSecondary.innerHTML = '';
    const secondaryBadges = dataSecondaryBadges
      .map((badge) => `<span class="badge badge--secondary">${badge}</span>`)
      .join('');
    badgeSecondary.innerHTML = secondaryBadges;
  }
}

function initVariantImages() {
  const mainContent = document.querySelector('#MainContent');

  if (!mainContent) return;

  // Event handler function
  function handleEvent(event) {
    const target = event.target.closest('.variant-image');
    if (!target) return;

    switch (event.type) {
      case 'mouseenter':
        handleImageHover(event);
        break;
      case 'mouseleave':
        handleImageMouseOut(event);
        break;
      case 'click':
        handleImageClick(event);
        break;
    }
  }

  // Attach event listeners to the #product-grid element
  mainContent.addEventListener('mouseenter', handleEvent, true);
  mainContent.addEventListener('mouseleave', handleEvent, true);
  mainContent.addEventListener('click', handleEvent);
}

document.addEventListener('DOMContentLoaded', function () {
  getCollectionItemsCount();
  initVariantImages();
  initPreloadVariantImages();
  /* Making functions globally accessible for DY slider */
  window.handleImageHover = handleImageHover;
  window.handleImageClick = handleImageClick;
  window.getCollectionItemsCount = getCollectionItemsCount;
});

function ajaxinateCallBack() {
  updateProductCount();
  document.querySelector('collection-load-more')?.updateCount?.();
  initPreloadVariantImages();
}

function updateProductCount() {
  const countParagraphTop = document.getElementById('ProductCount');
  if (countParagraphTop) {
    const countParagraphVal = countParagraphTop.getAttribute('itemcount');
    if (countParagraphVal && parseInt(countParagraphVal, 10) >= 1) {
      countParagraphTop.textContent = countParagraphTop.textContent.replace(/\d+/g, countParagraphVal);
    }
  }
  // Load-more count is updated by collection-load-more.js updateCount() (called from ajaxinateCallBack)
}

function getCollectionItemsCount() {
  if (!window.collection_handle) {
    return;
  }
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  searchParams.delete('page');
  const newUrl = `/collections/${collection_handle}?view=products-count&${searchParams.toString()}`;

  // Perform fetch request
  fetch(newUrl)
    .then((response) => response.text())
    .then((text) => {
      const lines = text.split('\n').filter((line) => line.trim().length > 0);
      const itemCount = lines.join('\n');
      let countParagraphTop = document.getElementById('ProductCount');

      if (!!countParagraphTop) {
        countParagraphTop.textContent = countParagraphTop.textContent.replace(/\d+/g, itemCount);
        countParagraphTop.style.display = 'block';
        countParagraphTop.setAttribute('itemCount', itemCount);
      }
      const loadMoreWrap = document.querySelector('.load-more');
      if (loadMoreWrap) {
        loadMoreWrap.dataset.totalCount = itemCount;
      }

      ajaxinateCallBack();
    })
    .catch((error) => console.error('Error fetching item count:', error));
}

function customBuildRedirect(productURL) {
  var current_url = productURL;
  if (!current_url.includes('?view=custom-watches')) {
    window.location.href = current_url + (current_url.includes('?') ? '&' : '?') + 'view=custom-watches';
  }
}

function facetsApplied() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  return url.searchParams.toString().length > 0;
}

function initPreloadVariantImages() {
  const gridItems = document.querySelectorAll(`[data-grid-item]:not(.prelaoded)`);

  // Create the Intersection Observer
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Get the target element
          const gridItem = entry.target;
          const images = gridItem.querySelectorAll('.variant-image img');
          const hoverImage = gridItem.querySelector('[data-card-hover-image]');

          images.forEach((image) => {
            const imgUrl = image.getAttribute('data-src');
            preloadImage(imgUrl);
          });

          hoverImage?.src && preloadImage(hoverImage?.src);

          gridItem.classList.add('prelaoded');

          observer.unobserve(gridItem);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }
  );

  // Observe each element
  gridItems.forEach((item) => {
    observer.observe(item);
  });
}

function preloadImage(imgUrl) {
  let img = new Image();
  img.src = imgUrl;
}
